<template>
	<div id="useradd">
		<div class="bm_h">
			<h3> 注册</h3>
		</div>
		<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
			<Row type="flex" justify="center" align="middle">
				<FormItem label="用户名" prop="userLoginId">
					<Input v-model="formValidate.userLoginId" placeholder="请输入用户名"></Input>
				</FormItem>
			</Row>
			<Row type="flex" justify="center" align="middle">
				<FormItem label="昵称" prop="otherName">
					<Input v-model="formValidate.otherName" placeholder="请输入昵称"></Input>
				</FormItem>
			</Row>
			<Row type="flex" justify="center" align="middle">
				<FormItem label="邮箱" prop="userEmail">
					<Input v-model="formValidate.userEmail" placeholder="请输入邮箱"></Input>
				</FormItem>
			</Row>
			<Row type="flex" justify="center" align="middle">
				<FormItem label="密码" prop="userPassword">
					<Input type="password" v-model="formValidate.userPassword"></Input>
				</FormItem>

			</Row>
			<Row type="flex" justify="center" align="middle">
				<div>
					<!-- 提示:密码必须由 4-16位字母、数字、特殊符号组成 -->
					提示:密码由字母+数字组成且总长度4-16位
				</div>
			</Row>

			<Row type="flex" justify="center" align="middle">
				<FormItem label="确认密码" prop="userPasswordCheck">
					<Input type="password" v-model="formValidate.userPasswordCheck"></Input>

				</FormItem>
			</Row>
			<Row type="flex" justify="center" align="middle">
				<Col>
				<FormItem label="验证码" prop="valid">
					<Input id='valid' v-model="formValidate.valid" placeholder="验证码"> </Input>
					<img id='imageId' :src="this.verificationImg" @click="changeImageNew">
				</FormItem>
				</Col>
			</Row>

			<Row type="flex" justify="center" align="middle">
				<FormItem label="省份" prop="provinceCode">
					<!-- :label-in-value="true" 方法checkDataChange 能获得value和label 没有则只能获得value -->
					<Select v-model="formValidate.provinceCode" placeholder="请选择省份" :label-in-value="true"
						@on-change="checkDataChange">
						<Option v-for="(item,index)  in provinces" :value="item.cityCode" :label="item.cityName"
							:key="index">{{item.cityName}}
						</Option>
					</Select>
				</FormItem>
			</Row>
			<Row type="flex" justify="center" align="middle">
				<FormItem label="城市" prop="cityCode">
					<Select v-model="formValidate.cityCode" placeholder="请选择城市" :label-in-value="true"
						@on-change="checkCityChange">
						<Option v-for="(item1,index)  in cityList" :value="item1.cityCode" :label="item1.cityName"
							:key="index">
							{{item1.cityName}}
						</Option>
					</Select>
				</FormItem>
			</Row>
			<Row justify="center" align="middle">
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 20px">重置</Button>
				</FormItem>
			</Row>
		</Form>
	</div>
</template>




<script>
	import {
		getXyCityCode,
		getSameUser,
		getValidImage,
		postNormalUserRegiser
	} from '@/network/index.js';


	//查询省份的参数
	const paramter = {
		cityLevel: 1
	};

	let provinceName;
	let cityName;

	export default {
		name: 'NormalUserRegiser',
		components: {

		},
		data() {

			//判断密码输入的是否正确
			const validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					//  密码长度最少8位、必须包含字母和数字 必须包含$或*号
					console.log("-------:" + value.length)
					//                if(value.length<8){
					//  callback(new Error('密码长度小于8位数！'));
					// }
					//密码验证
					//let passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/

					//let passwordreg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{4,16}$/;
					let passwordreg = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{4,16}$/;
					let isValid = passwordreg.test(value);
					if (isValid == false) {
						// callback(new Error('密码必须由 4-16位字母、数字、特殊符号线组成！'));
						callback(new Error('密码由字母+数字组成且总长度4-16位！'));
					}


					if (this.formValidate.userPasswordCheck !== '') {
						// 对第二个密码框单独验证
						this.$refs.formValidate.validateField('userPasswordCheck');
					}
					callback();
				}
			};
			//判断确认密码是否输入以及和第一次输入的是否一致
			const validatePassCheck = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.formValidate.userPassword) {
					callback(new Error('两次输入的密码不一样!'));
				} else {
					callback();
				}
			};

			//判断用户名是否已经存在
			const validateUserLoginId = (rule, value, callback) => {
				// 检查是否为空
				    if (value === '') {
				        callback(new Error('请输入用户名'));
				        return;
				    }
				
				    // 检查是否包含汉字
				    const chineseRegex = /[\u4e00-\u9fa5]/;
				    if (chineseRegex.test(value)) {
				        callback(new Error('用户名不能包含汉字'));
				        return;
				    }

                    let sameCount = 0;
					getSameUser({
							userLoginId: value
						}).then(res => {
							//console.log('res.obj:'+ res.data.obj);
							sameCount = res.data.obj;
							if (sameCount > 0) {
								callback(new Error('用户名已存在，请重新你输入!'));
							} else {
								callback();
							}
						})
						.catch(error => {
							this.$Message.success('后台出错，请联系管理员!');
						});


				 
			};


			return {
				formValidate: {
					userLoginId: '',
					otherName: '',
					userEmail: '',
					userPassword: '',
					userPasswordCheck: '',
					provinceCode: '',
					provinceName: '',
					cityCode: '',
					cityName: '',
					valid: ''

				},

				verificationImg: '',
				paramter,

				provinces: [],
				cityList: [],
				ruleValidate: {
					userLoginId: [{
						required: true,
						validator: validateUserLoginId,
						trigger: 'blur' //失去焦点事件
					}],
					otherName: [{
						required: true,
						message: '昵称必须填写，最大长度8',
						trigger: 'blur',
						max: 8,

					}],
					userEmail: [{
							required: true,
							message: '邮箱是必填项,找回密码时使用',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '邮箱格式不对',
							trigger: 'blur'
						}
					],
					userPassword: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					userPasswordCheck: [{
						required: true,
						validator: validatePassCheck,
						trigger: 'blur'
					}],
					provinceCode: [{
						message: '请选择省份',
						trigger: 'change'
					}],
					cityCode: [{
						message: '请选择城市',
						trigger: 'change'
					}],
					valid: [{
						required: true,
						message: '验证码必须填',
						trigger: 'blur'
					}],
				}
			}
		},


		created() {

			//获取省市的数据
			getXyCityCode(paramter).then(res => {
					// console.log(res);
					// console.log(''+res.data.obj.length+'');
					for (var i = 0; i < res.data.obj.dataList.length; i++) {
						this.provinces.push({
							cityCode: res.data.obj.dataList[i].cityCode,
							cityName: res.data.obj.dataList[i].cityName
						});


					}

				})
				.catch(error => {});


			//调用展示图片的方法
			this.changeImage();

		},

		methods: {
			changeImageNew() {
				//调用展示图片的方法
				this.changeImage();
			},

			changeImage() {
				getValidImage().then(res => {
						this.verificationImg = window.URL.createObjectURL(res.data)
					})
					.catch(error => {});


			},
			checkCityChange(val) {
				cityName = val.label; //获取label
			},
			checkDataChange(val) {
				provinceName = val.label; //获取label
				let parentCodeTemp = val.value; //获取value
				let parCity = {
					parentCode: parentCodeTemp,
				}
				getXyCityCode(parCity).then(res => {
						//先清空一下数据，否则之前加载的数据也在 
						this.cityList = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							//this.cityList.clear();
							this.cityList.push({
								cityCode: res.data.obj.dataList[i].cityCode,
								cityName: res.data.obj.dataList[i].cityName
							});
						}

					})
					.catch(error => {

					});
			},



			handleSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						let formdata = {
							userLoginId: this.formValidate.userLoginId,
							otherName: this.formValidate.otherName,
							userEmail: this.formValidate.userEmail,
							userPassword: this.formValidate.userPassword,
							provinceCode: this.formValidate.provinceCode,
							provinceName: provinceName,
							cityCode: this.formValidate.cityCode,
							cityName: cityName,
							//sessionId: this.$store.state.sessionId,
							valid: this.formValidate.valid,

						};
						//debugger
						postNormalUserRegiser(formdata).then(res => {

								if (res.code == '500') {
									this.$Message.error(res.message + ',请重新注册');
								} else {

									console.log('res:' + res);
									let resultCode = res.obj;

									console.log('resultCode:' + resultCode);
									// 1: 验证码的值不能为空
									// 2: 验证码获取失败
									// 3: 验证码不匹配
									if (resultCode == '1') {
										this.$Message.error({
											background: true,
											content: '验证码的值不能为空!'
										});
									} else {
										if (resultCode == '2') {
											this.$Message.error({
												background: true,
												content: '验证码获取失败!'
											});
										} else {
											if (resultCode == '3') {
												this.$Message.error({
													background: true,
													content: '验证码不匹配!'
												});
											} else {
													this.$Message.success('注册成功!');
													this.$router.push('/login')
											}
										}

									}

								}

							})
							.catch(error => {
								this.$Message.success('注册失败，请联系管理员!');
							});


					} else {
						this.$Message.error('数据校验失败，请修改后重新提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},
	}
</script>

<style lang="scss" scoped>
	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}

	.bm_h {
		padding: 0 10px;
		height: 50px;
		border-top: 1px solid #FFF;
		border-bottom: 1px solid #e3e2db;
		background: #F2F2F2;
		line-height: 50px;

	}


	.ivu-input-wrapper {
		width: 300px;

	}

	.ivu-form-item-label {
		text-align: center;
	}

	.ivu-form-item-content {
		text-align: left;
	}

	.ivu-select {
		width: 300px;
	}



	#weixin {
		line-height: 20px;
		top: 10px;
		left: 10px;
		position: absolute;
	}

	#weixin-logo {
		width: 30px;
		height: 30px;
		border-radius: 3px; //添加圆角
	}

	#weixin-word {
		width: 60px;
		height: 20px;
		position: relative;
		left: 300px;
	}

	#head {
		line-height: 20px;
		top: 22px;
		left: 10px;
		position: absolute;
	}

	#head-logo {
		width: 60px;
		height: 60px;
		border-radius: 3px; //添加圆角
		position: relative;
		left: 300px;

	}

	#head-select {
		width: 200px;
		height: 30px;
		bottom: 20px;
		border-radius: 1px; //添加圆角
		position: relative;
		left: 300px;

	}

	label {
		position: relative;
	}

	#fileinp {
		position: absolute;
		left: 0px;
		top: 0;
		opacity: 0;
	}

	#btn {
		margin-right: 5px;
	}


	#head-word {
		width: 60px;
		height: 20px;
		position: relative;
		top: 15px;
		left: 240px;
	}

	#imageId {
		width: 120px;
		height: 30px;
		position: absolute;
		left: 180px;
		top: 2px;
	}

	#useradd {
		border-style: solid;
		border-width: 1px;
		border-color: #bebdbc;
	}
</style>
